/**
 * Class to load Script Flowbox
 */
export default class LoadFlowboxChunk {
  constructor() {
    const sliderFlowboxElement: HTMLElement =
      document.querySelector('.c-flowbox');

    // Load Slider Flowbow
    if (sliderFlowboxElement) {
      LoadFlowboxChunk.importFlowboxChunks(sliderFlowboxElement);
    }
  }

  /**
   * Import SliderFlowbox
   *
   */
  private static importFlowboxChunks(sliderFlowboxElement: HTMLElement) {
    const flowboxKeysAttr = sliderFlowboxElement.dataset.keyFlowbox;
    const fallbackLocale = 'fr-FR';
    const locale = sliderFlowboxElement.dataset.locale ?? fallbackLocale;
    const flowboxKeys = JSON.parse(flowboxKeysAttr || '{}');
    const keyFlowbox = flowboxKeys[locale] || flowboxKeys[fallbackLocale] || '';

    import(
      /* webpackPrefetch: true */ /* webpackChunkName: 'prefetch-SliderFlowbox' */ '../../../components/Flowbox/Flowbox'
    ).then(({ default: Flowbox }) => {
      new Flowbox(sliderFlowboxElement, keyFlowbox);
    });
  }
}
